// assets/benefits-5-cards.js
(() => {
  const SELECTOR_SECTION = ".benefits-5";
  const SELECTOR_GRID = "[data-cards-grid]";
  const MOBILE_MAX = 989; // <= 989px = mobile/tablet (ajústalo si quieres)

  const flickityOptions = {
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: true,
    wrapAround: false,
    draggable: true,
    adaptiveHeight: true,
    imagesLoaded: true
  };

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  function initSection(sectionEl) {
    const grid = sectionEl.querySelector(SELECTOR_GRID);
    if (!grid) return;

    // guardamos instancia en dataset / property
    sectionEl.__benefitsFlickity = sectionEl.__benefitsFlickity || null;

    const enableSlider = () => {
      if (sectionEl.__benefitsFlickity) return;

      // Flickity requiere "cells" como hijos directos
      // Tus cards ya son los hijos de .benefits-5__grid, perfecto.
      sectionEl.__benefitsFlickity = new Flickity(grid, flickityOptions);

      // Clase útil para CSS específico de modo slider
      sectionEl.classList.add("benefits-5--slider");
    };

    const disableSlider = () => {
      if (!sectionEl.__benefitsFlickity) return;

      sectionEl.__benefitsFlickity.destroy();
      sectionEl.__benefitsFlickity = null;
      sectionEl.classList.remove("benefits-5--slider");
    };

    // inicial
    if (isMobile()) enableSlider();

    // reacciona a resize/orientation change
    const onResize = () => {
      if (isMobile()) enableSlider();
      else disableSlider();
    };

    // evita spamear resize
    let t = null;
    window.addEventListener("resize", () => {
      clearTimeout(t);
      t = setTimeout(onResize, 150);
    });
  }

  function boot() {
    document.querySelectorAll(SELECTOR_SECTION).forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", boot);

  // Shopify Theme Editor (cuando agregas/mueves secciones)
  document.addEventListener("shopify:section:load", (e) => {
    const sectionEl = e.target;
    if (sectionEl && sectionEl.matches && sectionEl.matches(SELECTOR_SECTION)) {
      initSection(sectionEl);
    }
  });
})();